export default "__VITE_ASSET__BCpRml8O__"